var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{class:_vm.$style.container},[_c('a',{class:[{ ContentTeaserM__videoLink: _vm.isVideo }, _vm.$style.mediaLink],attrs:{"href":_vm.primaryLink,"target":_vm.primaryLinkNewWindow ? '_blank' : '_self',"aria-label":"goto detail"},on:{"click":function($event){_vm.wtParams &&
        _vm.wtTrack(
          {
            cat: _vm.wtParams.doctype
          },
          _vm.mergeWtParams(
            _vm.wtParams,
            {
              filename: _vm.primaryLink
            },
            {}
          )
        )}}},[_c('div',{class:_vm.$style.image,style:({ backgroundImage: ("url(" + _vm.image + ")") })},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),(_vm.isVideo)?_c('i',{staticClass:"fab fa-youtube"}):_vm._e()]),_c('figcaption',[(_vm.category)?_c('a',{class:_vm.$style.secondaryLink,attrs:{"href":_vm.secondaryLink,"target":_vm.secondaryLinkNewWindow ? '_blank' : '_self'}},[_vm._v(_vm._s(_vm.category)+"\n    ")]):_vm._e(),(_vm.linkTitle)?_c('a',{class:_vm.$style.primaryLink,attrs:{"href":_vm.primaryLink,"target":_vm.primaryLinkNewWindow ? '_blank' : '_self'},on:{"click":function($event){_vm.wtParams &&
          _vm.wtTrack(
            {
              cat: _vm.wtParams.doctype
            },
            _vm.mergeWtParams(
              _vm.wtParams,
              {
                filename: _vm.primaryLink
              },
              {}
            )
          )}}},[_vm._v("\n      "+_vm._s(_vm.linkTitle)+"\n      "),(_vm.text)?_c('div',[_vm._v(_vm._s(_vm.text))]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }